import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { toast } from "sonner"
import { useTranslation } from "react-i18next"

export const useBackofficeLaunchCampaignMutation = (id: string) => {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (customerId: string) => {
      const { data } = await axios.post(`/backoffice/campaigns/trigger/${id}`, { customerId })
      return data.data
    },
    onSuccess: () => {
      toast.success(t("campaigns.detail.backofficeLaunchCampaign.launchSuccess"))
    },
  })
}
